type AudioTask = () => Promise<void>

/**
 * Runs audio (and scene-transition) tasks strictly in order. A failing task
 * must never wedge the queue — scene transitions ride on it, so a stuck
 * queue means a frozen game.
 */
export class AudioQueueManager {
  private queue: AudioTask[] = []
  private isPlaying = false

  public enqueue(task: AudioTask) {
    this.queue.push(task)
    if (!this.isPlaying) {
      void this.playNext()
    }
  }

  /**
   * Drops every task that has not started yet. The running task is left
   * alone (it owns its own watchdogs and will resolve on its own terms),
   * so callers that want it gone must cancel it through its service.
   */
  public clearPending(): void {
    this.queue.length = 0
  }

  private async playNext(): Promise<void> {
    const task = this.queue.shift()
    if (!task) {
      this.isPlaying = false
      return
    }

    this.isPlaying = true
    try {
      await task()
    } catch (error) {
      console.error('Audio task failed, continuing queue:', error)
    }
    void this.playNext()
  }
}
